// src/pages/Billing.jsx
import React, { useState } from "react";
import { auth } from "../../firebase";
import { createPortalSession } from "../../api/subscriptions";
import { useAuth } from "../../auth";

export default function Billing() {
  const { subscription, supportAccount } = useAuth();
  const isFree = String(subscription?.plan?.name || "").trim().toLowerCase() === "free";
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  if (supportAccount) {
    return (
      <div className="container py-5 text-center">
        <h1 className="fw-bold mb-2">Subscription</h1>
        <div className="alert alert-warning mt-4">
          Billing changes are unavailable during support access.
        </div>
      </div>
    );
  }

  const handleManageBilling = async () => {
    setLoading(true);
    setError(null);

    try {
      const user = auth.currentUser;
      if (!user) throw new Error("You must be signed in to manage billing.");

      const returnUrl = window.location.href;
      const json = await createPortalSession({ uid: user.uid, returnUrl });
      const url = json?.result?.url;
      if (!url) throw new Error("Stripe portal URL not returned.");

      window.location.assign(url);
    } catch (e) {
      setError(e?.message || "Unable to open billing portal.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container py-5 text-center">
      <h1 className="fw-bold mb-2">Subscription</h1>
      {isFree ? (
        <>
          <p className="text-muted mx-auto" style={{ maxWidth: 640 }}>
            You are on the Free plan. Upgrade when you are ready to add attractions.
          </p>
          <a className="btn btn-primary mt-4" href="https://bouncehouse.com/businesses#pricing">
            View Upgrade Options
          </a>
        </>
      ) : (
        <>
      <p className="text-muted mx-auto" style={{ maxWidth: 640 }}>
        Manage your subscription, payment method, and invoices in Stripe.
      </p>

      <button
        type="button"
        className="btn btn-primary mt-4"
        onClick={handleManageBilling}
        disabled={loading}
      >
        {loading ? "Opening billing portal…" : "Open Stripe Billing Portal"}
      </button>
        </>
      )}

      {error ? (
        <div className="alert alert-danger mt-4" role="alert">
          {error}
        </div>
      ) : null}
    </div>
  );
}
